import { clsx, type ClassValue } from "clsx";
import { toast } from "sonner";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function handleErrorMessage(error: any, message: string) {
	toast.error(
		message,
		error.message.includes("You’ve reached the daily limit")
			? {
					description: error.message,
				}
			: undefined,
	);
}
